import { render, staticRenderFns } from "./FirstStaff.vue?vue&type=template&id=585188f9&scoped=true&"
import script from "./FirstStaff.vue?vue&type=script&lang=js&"
export * from "./FirstStaff.vue?vue&type=script&lang=js&"
import style0 from "./FirstStaff.vue?vue&type=style&index=0&id=585188f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585188f9",
  null
  
)

export default component.exports